import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import { Form } from "react-bootstrap";
import RequestControls from "containers/request/RequestControls";
import Instructions from "containers/request/OTA/OTADeviceInfoBubble";
import RequestManufacturer from "components/request/RequestManufacturer";
import RequestModelName from "components/request/RequestModelnameSimple";
import BatteryVoltageCapacity from "components/request/BatteryVoltageCapacity";
import RequestRevision from "components/request/RequestRevision";
import PackCells from "containers/request/battery/PackCellsWithRecognition/PackCellsWithRecognition";
import PackCellsReadonly from "components/request/PackCellsReadonly";
import NonSarSites from "containers/request/battery/NonSarSites/NonSarSites";
import NonSarSitesReadonly from "containers/request/battery/NonSarSites/NonSarSitesReadonly";
import SubmissionDetails from "containers/request/RequestContent/SubmissionDetails";
import { setValue, setBatteryRequestPermissions } from "actions/request";
import { initPRR, updateDeviceInfoPRR } from "actions/battery/prrRequest";
import { mapNonSarManufSites } from "actions/battery/batteryRequests";
import { submitWizardStep } from "actions/wizard";
import { ifModelExists } from "actions/model";
import { hasStringValue } from "helpers/RequestHelper";
import { validateCapacity, validateVoltage } from "helpers/ValidatorHelper";
import { getRequestOwner } from "helpers/UsersHelper";

class RequestContainerPRR extends React.Component {
  updatePermissions = () => {
    const { request, user, setBatteryRequestPermissions } = this.props;
    setBatteryRequestPermissions(request, user);
  };

  componentDidMount() {
    const { request } = this.props;

    // fetch only for the first time on submissions
    if (!this.validate() && !request.id) {
      this.props.initPRR();
    }

    this.updatePermissions();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user.togglerEnabled !== this.props.user.togglerEnabled) {
      this.updatePermissions();
    }
  }

  onSaveClick = () => {
    const {
      request,
      sites,
      user,
      ifModelExists,
      updateDeviceInfoPRR
    } = this.props;

    const modelNameUntouched =
      request.modelName === request.__orig.vendorproductname;

    if (!modelNameUntouched) {
      // admins also can edit request
      const ownerId = getRequestOwner(request, user);

      ifModelExists(request.modelName, ownerId).then(isUnique => {
        // allow to update in case only modelname is unique
        if (isUnique) {
          updateDeviceInfoPRR(request, sites.nonSarSites);
        }
      });
    } else {
      updateDeviceInfoPRR(request, sites.nonSarSites);
    }
  };

  onContinueClick = () => {
    const { request, user, ifModelExists } = this.props;

    ifModelExists(request.modelName, user.companyid).then(isUnique => {
      if (isUnique) {
        return this.props.submitWizardStep();
      }
    });
  };

  validateModel() {
    return hasStringValue(this.props.request, "modelName");
  }

  validateRevision() {
    return hasStringValue(this.props.request, "revision");
  }

  validateManufSites() {
    const { sites } = this.props;

    return sites && sites.nonSarSites && _.some(sites.nonSarSites, "checked");
  }

  validatePackCells() {
    const { request } = this.props;

    return request.cellSuppliers && request.cellSuppliers.length > 0;
  }

  validate() {
    const { request, user } = this.props;
    const { canEditDeviceInfo } = user;

    // don't need to validate if form is non-editable
    if (canEditDeviceInfo === false) return true;

    // check Voltage/Capacity values
    if (!validateCapacity(request) || !validateVoltage(request)) return false;

    // check if all required fields are valid
    return (
      this.validateModel() &&
      this.validateRevision() &&
      this.validateManufSites() &&
      this.validatePackCells()
    );
  }

  render() {
    const { canEditDeviceInfo } = this.props.user;
    const saveHandler = canEditDeviceInfo ? this.onSaveClick : null;
    const isEditable = { editable: canEditDeviceInfo };

    return (
      <div>
        <Instructions />
        <Form horizontal>
          <RequestManufacturer />
          <RequestModelName />
          <RequestRevision fieldId="revision" {...isEditable} />
          <BatteryVoltageCapacity />
          <SubmissionDetails />
          <hr />
          {canEditDeviceInfo ? <NonSarSites /> : <NonSarSitesReadonly />}
          <hr />
          {canEditDeviceInfo ? <PackCells /> : <PackCellsReadonly />}
          <RequestControls
            isValid={this.validate()}
            onSave={saveHandler}
            onContinue={this.onContinueClick}
          />
        </Form>
      </div>
    );
  }
}

function mapStateToProps({ app, request, user, sites, preloader }) {
  return { app, request, user, sites, preloader };
}

export default connect(mapStateToProps, {
  initPRR,
  submitWizardStep,
  updateDeviceInfoPRR,
  setValue,
  setBatteryRequestPermissions,
  mapNonSarManufSites,
  ifModelExists
})(RequestContainerPRR);
